import { AlertCircle, X } from "lucide-react";
import { Button } from "react-aria-components";
import { twMerge } from "tailwind-merge";

type BannerVariant = "info";

type BannerProps = {
  children?: React.ReactNode;
  className?: string;
  onClose?: () => void;
  title: string;
  variant: BannerVariant;
};

const variantConfig = {
  info: {
    bgColor: "bg-bg-primary-alt",
    borderColor: "border-border-primary",
    icon: AlertCircle,
    iconColor: "bg-bg-error-secondary",
  },
};

export function Banner({
  children,
  className,
  onClose,
  title,
  variant,
}: BannerProps) {
  const config = variantConfig[variant];
  const Icon = config.icon;

  return (
    <div
      className={twMerge(
        `flex gap-xl rounded-xl border p-xl`,
        config.borderColor,
        config.bgColor,
        className,
      )}
    >
      <div className="grid size-5xl place-items-center rounded-full bg-bg-error-secondary">
        <Icon className="text-text-error-primary" size={20} />
      </div>
      <div className="flex flex-col flex-1">
        <span className="text-sm font-medium text-text-primary">{title}</span>
        <div className="flex items-center gap-2">{children}</div>
      </div>
      {onClose && (
        <Button
          className="ml-auto grid size-2xl place-items-center"
          onPress={onClose}
        >
          <X className="text-border-brand-solid" size={12} />
        </Button>
      )}
    </div>
  );
}
